interface IMessageProps {
    content: string;
    duration?: number;
}

const showToast = (props: IMessageProps | string, type?: 'success' | 'error' | 'warning') => {
    const title = typeof props === 'string' ? props : props.content;
    const autoClose = typeof props === 'string' ? 2000 : props.duration || 2000;

    window.NYX.Modal({
        type: type || 'toast',
        className: 'mall-web-toast',
        title,
        autoClose,
    });
};

export const message = {
    success: (props: IMessageProps | string) => {
        showToast(props, 'success');
    },
    error: (props: IMessageProps | string) => {
        showToast(props, 'error');
    },
    warning: (props: IMessageProps | string) => {
        showToast(props, 'warning');
    },
    info: (props: IMessageProps | string) => {
        showToast(props);
    },
};
